
"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../../../../components/navbar";
import Footer from "../../../../../../components/footer";
import styles from "../../../css/Transactions/DebtorsTransactionsList.module.css";
import { LuChartBar, LuFileStack, LuFileText } from "react-icons/lu";

export default function DebtorsAccountOptions() {
  const navigate = useNavigate();
  const location = useLocation();

  const transaction = (() => {
    const fromState = location.state?.transaction || null;
    if (fromState) return fromState;
    try {
      const raw = sessionStorage.getItem("debtors_selected_transaction");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  return (
    <div className={styles.wrapper}>
      <Navbar backTo="/frontshop/debtors/transactions" />

      <main className={styles.optionsMain}>
        <div className={styles.optionsGrid}>
          <button
            className={styles.optionCard}
            onClick={() => {
              navigate("/frontshop/debtors/transactions/options/invoices", { state: { transaction } });
            }}
          >
            <div className={styles.optionIcon} aria-hidden="true">
              <LuFileText />
            </div>
            <div className={styles.optionLabel}>Invoices</div>
          </button>

          <button
            className={styles.optionCard}
            onClick={() => {
              navigate("/frontshop/debtors/transactions/options/account-summary", { state: { transaction } });
            }}
          >
            <div className={styles.optionIcon} aria-hidden="true">
              <LuChartBar />
            </div>
            <div className={styles.optionLabel}>Account Summary</div>
          </button>

          <button
            className={styles.optionCard}
            onClick={() => {
              navigate("/frontshop/debtors/transactions/options/statements", { state: { transaction } });
            }}
          >
            <div className={styles.optionIcon} aria-hidden="true">
              <LuFileStack />
            </div>
            <div className={styles.optionLabel}>Statements</div>
          </button>
        </div>
      </main>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
